import React from "react";
import { useAppContext } from "../../context/appContext";
import { Display } from "../../components/workspace";
import { numberToMoney } from "../../utils/money";
import { calcOptionTotal, calcCommissions } from "../../utils/calcOptionTotal";

function PriceSummary({reviewItems, reviewFees, reviewDiscounts, reviewOption, reviewJob}) {
	const { lists, prices } = useAppContext();

	const { grandTotal, ttlCostTax, ttlCostMaterials, ttlCostLabor, profitTotal } = calcOptionTotal({
		jobItems: reviewItems,
		fees: reviewFees,
		discounts: reviewDiscounts,
		sales_tax: reviewOption?.salesTax,
		job: reviewJob,
		prices,
	});

	const totatCost = ttlCostTax + ttlCostMaterials + ttlCostLabor;

	const commissions = prices?.commissions?.filter((row) => row.price_sheets_id === reviewJob?.price_sheets_id)[0];

  	const { workCommission, saleCommission } = calcCommissions({
		salesReps: reviewJob?.sale_commission_ids,
		serviceReps: reviewJob?.service_commission_ids,
		profit: profitTotal,
		listServiceReps: lists.listServiceReps,
	    jobType: reviewJob?.job_type_id,
	    commissions,
	});

	return (
		<>
			<h3 className="whole">Price Summary</h3>
			<div className="form-row one-third">
				<Display name="Cost Tax" value={numberToMoney(ttlCostTax)} />
				<Display name="Cost Materials" value={numberToMoney(ttlCostMaterials)} />
				<Display name="Cost Labor" value={numberToMoney(ttlCostLabor)} />
				<Display name="Total Cost" value={numberToMoney(totatCost)} />
			</div>
			<div className="form-row one-third">
				<Display name="Job Total" value={numberToMoney(grandTotal)} />
				<Display name="Total Cost" value={numberToMoney(totatCost)} />
				<Display name="Total Profit" value={numberToMoney(profitTotal)} />
			</div>
			<div className="form-row one-third">
				<Display name="Total Sales Commission(s)" value={numberToMoney(saleCommission)} />
				<Display name="Total Service Commission(s)" value={numberToMoney(workCommission)} />
				<Display
					name="Company Profit"
					value={numberToMoney(profitTotal - saleCommission - workCommission)}
				/>
			</div>
		</>
	);
}
export default PriceSummary;

